
<template>
  <div>
    <chc-loader ref="loader"></chc-loader>
    <chc-modal ref="addUserModal" title="Add New User">
      <div slot="body">
        <users-add
          v-on:refresh="refresh"
          v-on:close="addUserHide"
          ></users-add>
      </div>
    </chc-modal>
    <chc-modal ref="editUserModal" title="Edit User">
      <div slot="body">
        <users-edit
          :data="editData"
          :userId="editId"
          v-on:refresh="refresh"
          v-on:close="editUserHide"
          ></users-edit>
      </div>
    </chc-modal>
    <datatable
        :source="users"
        :isLoading="isLoading"
      >
      <datatable-column
        v-for='(column, index) in columns'
        :id='column.id'
        :label='column.label'
        :key='index'
        >
      </datatable-column>

      <template slot="searchLeft">
        <a class="secondary-action" v-on:click="addUser">+ Add New User</a>
      </template>

      <template slot="source_template" slot-scope="data">
          <tr @click="gotoRow(data.row.id)">
              <td class="table-15" :class="{ 'deactivated' : !data.row.active }">{{ data.row.name }}</td>
              <td class="table-25" :class="{ 'deactivated' : !data.row.active }">{{ data.row.email }}</td>
              <td class="table-20" :class="{ 'deactivated' : !data.row.active }">{{ data.row.user_role }}</td>
              <td class="table-20" :class="{ 'deactivated' : !data.row.active }">{{ data.row.charity }}</td>
              <td class="table-20" :class="{ 'deactivated' : !data.row.active }">{{ data.row.call_center }}</td>
          </tr>
      </template>
    </datatable>
  </div>
</template>

<script>
import Datatable from '@/components/Datatables/AppDatatable'
import DatatableColumn from '@/components/Datatables/AppDatatableColumn'
import UsersAdd from '@/components/Users/UsersAdd'
import UsersEdit from '@/components/Users/UsersEdit'
import store from '@/store'

export default {
  name: 'UsersSummary',
  mounted () {
    this.refresh()
  },
  data () {
    return {
      columns: [
        { id: 'name', label: 'Name' },
        { id: 'email', label: 'Email' },
        { id: 'user_role', label: 'User Type' },
        { id: 'charity', label: 'Charity' },
        { id: 'call_center', label: 'Call Center' }
      ],
      isLoading: true,
      editData: {
        first_name: '',
        last_name: '',
        email: '',
        user_role: '',
        charity_id: '',
        call_center_id: ''
      },
      editId: null,
      users: []
    }
  },
  components: {
    Datatable,
    DatatableColumn,
    UsersAdd,
    UsersEdit
  },
  methods: {
    gotoRow (rowId) {
      this.$refs.loader.show()
      store.functions.users.getUser(rowId, (response) => {
        this.editData = response.data
        this.editId = rowId
      }).then(() => {
        this.$refs.loader.hide()
        this.$refs.editUserModal.show()
      })
    },
    addUser () {
      this.$refs.addUserModal.show()
    },
    addUserHide () {
      this.$refs.addUserModal.hide()
    },
    editUserHide () {
      this.$refs.editUserModal.hide()
    },
    refresh () {
      Promise.all([
        store.dispatch('syncConstants'),
        store.dispatch('syncSummary'),
        store.functions.users.usersTable((response) => { this.users = response.data })
      ]).finally(() => {
        this.isLoading = false
      })
    }
  }
}
</script>

<style>
  .deactivated {
    text-decoration: line-through;
  }
</style>



// WEBPACK FOOTER //
// src/components/Users/UsersSummary.vue